import { rem } from "@certn/cascadia";
import {
  Container,
  Layout,
  useColors,
  useMediaQuery,
  useShadows,
} from "@certn/cascadia-react";
import { shapes } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useEffect } from "react";

import { useAuth } from "./hooks";
import { AppFooter } from "../../components/AppFooter";

interface Props {
  children: React.ReactNode;
}

export function AuthLayout(props: Props) {
  const { children } = props;
  const { mediaQuery } = useMediaQuery();
  const { logout } = useAuth();
  const colors = useColors();
  const shadows = useShadows();

  useEffect(() => {
    // make sure user is logged out when visiting these routes
    logout();
  }, []);

  return (
    <div
      className={css(
        mediaQuery({
          backgroundColor: [
            colors["surface-overlay"],
            colors["surface-sunken"],
          ],
        })
      )}
    >
      <Layout layout="auth" backgroundColor={false} footer={<AppFooter />}>
        <Container>
          <div
            className={css(
              styles.card,
              {
                background: colors["surface-overlay"],
                padding: rem("space-6"),
                gap: rem("space-6"),
              },
              mediaQuery({
                padding: [rem("space-0"), rem("space-6")],
                borderRadius: [0, shapes["border-radius-3"]],
                marginTop: [0, rem("space-16")],
                boxShadow: [undefined, shadows["shadow-card"]],
              })
            )}
          >
            {children}
          </div>
        </Container>
      </Layout>
    </div>
  );
}

const styles = {
  container: css({
    minHeight: "100vh",
  }),
  card: css({
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    transition: "height 200ms",
  }),
};
